import apiClient from "utils/apiClient";
const base = "/care-service/api/v1/admin/prescription-reviews";
const unwrap = ({ data }) => data?.data ?? data;
export const prescriptionReviewService = {
  residents: (search) => apiClient.get(`${base}/residents`, { params: { search } }).then(unwrap),
  import: (resident, files, documents) => {
    const body = new FormData();
    body.append("residentId", resident.id);
    body.append("workspaceId", resident.workspaceId);
    body.append("document", JSON.stringify(documents));
    files.forEach(file => body.append("files", file));
    return apiClient.post(`${base}/import`, body, { headers: { "Content-Type": undefined }, timeout: 360000 }).then(unwrap);
  },
  list: (page = 0) => apiClient.get(base, { params: { page } }).then(unwrap),
  get: (id) => apiClient.get(`${base}/${encodeURIComponent(id)}`).then(unwrap),
  save: (id, data) => apiClient.put(`${base}/${encodeURIComponent(id)}`, data).then(unwrap),
  forward: (id, data) => apiClient.post(`${base}/${encodeURIComponent(id)}/forward`, data).then(unwrap),
  discard: (id) => apiClient.delete(`${base}/${encodeURIComponent(id)}`).then(unwrap),
};
